/* istanbul ignore file: Directive */
'use strict';

/**
 * A single step in a wizard.  Multiple steps form a single flow by binding them to the same wizard.
 *
 * attribute wizard: the wizard to bind to.  This will be automatically created in the scope.  (see utils.Wizard)
 * attribute wizard-step-valid: (optional) function to check if the current step is valid.  If not, the user cannot
 *      continue.
 * attribute wizard-submit: (optional) function to invoke after submitting this step.  If the function returns a
 *      promise, the step won't continue until the promise is resolved. If the promise is rejected instead,
 *      the continuation will be aborted.
 * attribute wizard-button-labels: (optional) labels for the previous/next button, separated by a pipe character.
 *      Any of the two can be omitted to take the default instead. e.g. "nope|yup" or "|go further" or "made a mistake|"
 * attribute wizard-if: (optional)  if this expression resolves to false, the step will be ommited.
 *
 * This directive expects its content to contain a form.  The step will only continue if the form is valid.
 * The wizard will automatically progress to the next step when enter is pressed inside a textfield.  To make an
 * exception to this rule, use the 'nosubmit' class to the textfield.
 */
customerZone.directive('wizardStep', ['$compile', '$log', '$q', 'utils', function($compile, $log, $q, utils){

    /** Little helper to parse labels */
    var parseLabels = function(input, previousDefault, nextDefault){
        input = input ? input.split('|'):['', ''];
        return {
            previousButton: input[0] === '' ? previousDefault : input[0],
            nextButton: input[1] === '' ? nextDefault : input[1]
        };
    };

    function applyInputField(inputField) {
        var ngModelCtrl = angular.element(inputField).controller('ngModel');
        if (ngModelCtrl) {
            ngModelCtrl.$commitViewValue();
            ngModelCtrl.$setTouched();
        }
    }

    return {
        scope: {wizardSubmit: '&', wizardOnEnter: '&', wizardIf: '=', wizardStepValid: '=', wizardButtonLabels: '@'},
        link: function(scope, element, attrs) {

            scope.wizard = utils.getOrCreate(scope.$parent, attrs.wizard, function(){ return new jim.Wizard($q); });
            scope.labels = parseLabels(scope.wizardButtonLabels, 'to_the_previous_step', 'to_the_next_step');

            var stepName = attrs.wizardStep;
            var enabled = attrs.wizardIf ? function(){ return scope.wizardIf; } : undefined;
            var step = scope.wizard.addStep(stepName, enabled);
            var $form = element.find('form');

            element.addClass('wizard-step');
            element.hide();

            // add prev/next buttons
            var $buttons = $('<p class="wizard-buttons">' +
                '<button ng-class="wizard.loading ? \'loading\' : \'enabled\'"' +
                '        ng-click="nextStep(); e.preventDefault()" ' +
                '        ng-bind="(wizard.loading ? \'loading\' : labels.nextButton) | translate" tabindex="0">' +
                '</button>');
            element.append($buttons);
            $compile($buttons)(scope);

            // go to next step when enter is pressed
            $form.find('input[type=text]').not('.nosubmit').keypress(function(e){
                if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)){
                    // we need to make sure the current input field is applied first
                    applyInputField(this);
                    scope.$apply(scope.nextStep);
                    return false;
                }
                else return true;
            });

            // show/hide step depending on wizard state
            var onWizardUpdate = function(){
                $form.removeClass('highlight-required');
                var show = scope.wizard.stepName === stepName && scope.wizard.step.enabled();
                element.toggle(show);
                element.toggleClass('current-step', show);
                element.find('h2').attr('data-stepidx', scope.wizard.getStepIndex());
                if (show){
                    var formCtrl = angular.element($form).controller('form');
                    if (formCtrl && formCtrl.updateFocus)
                        formCtrl.updateFocus();
                    if (scope.wizardOnEnter)
                        scope.wizardOnEnter();
                }
            };

            scope.$watch('wizard.stepName', onWizardUpdate);
            scope.$watch('wizard.step.enabled()', onWizardUpdate);

            scope.$watch('wizard.loading', function(newValue){
                $form.toggleClass('busy', newValue);
            });

            scope.scrollToWizardTop = function(){
                $('html, body').scrollTop(0);
            };

            scope.prevStep = function(){
                scope.wizard.prevStep();
            };

            scope.nextStep = function(){
                if (scope.wizard.loading) return;
                if (!scope.wizard.allowNext()) {
                    $form.addClass('highlight-required');
                    return;
                }

                return scope.wizard.nextStep()
                    .then(function(){
                        scope.scrollToWizardTop();
                    })
                    .catch(function(error){
                        $log.error('Could not progress step: ', error);
                    });
            };

            step.setupValidations(
                function(){
                    if (attrs.wizardStepValid && !scope.wizardStepValid) return false;
                    if ($form.attr('name') && !scope.$parent[$form.attr('name')].$valid) return false;
                    return true;
                }
            );

            step.submit = function(){ return scope.wizardSubmit(); };

            if (attrs.onEnterStep) {
                step.listeners.push(function(event){
                    if (event === 'enter')
                        scope.$parent.$eval(attrs.onEnterStep);
                });
            }

            if (attrs.onExitStep) {
                step.listeners.push(function(event){
                    if (event === 'exit')
                        scope.$parent.$eval(attrs.onExitStep);
                });
            }


        }
    };

}]);
